export default __webpack_public_path__ + "static/media/commuter-qr.b0134e41.png";